import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, unref as _unref } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "flex items-center py-4"
};
const _hoisted_2 = {
  key: 1,
  class: "flex-center py-4 text-gray-600"
};
const _hoisted_3 = {
  class: "flex items-center"
};
const _hoisted_4 = {
  class: "grow"
};
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = {
  class: "flex items-center px-4"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  class: "flex items-center bg-slate-50 py-2 px-4 -mx-2 mb-6 border-y border-slate-200 mt-2"
};
const _hoisted_9 = {
  class: "flex flex-col mr-4"
};
const _hoisted_10 = {
  class: "text-gray-400"
};
const _hoisted_11 = {
  class: "flex items-center"
};
const _hoisted_12 = {
  class: "flex flex-col mr-4"
};
const _hoisted_13 = {
  class: "text-gray-400"
};
const _hoisted_14 = {
  class: "text-2xl"
};
const _hoisted_15 = {
  class: "flex flex-col"
};
const _hoisted_16 = {
  class: "text-gray-400"
};
const _hoisted_17 = {
  class: "text-2xl"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "grow"
}, null, -1);
const _hoisted_19 = {
  class: "flex-center"
};
const _hoisted_20 = {
  class: "font-bold mb-1"
};
const _hoisted_21 = {
  class: "flex items-center"
};
const _hoisted_22 = {
  class: "w-32 mr-2 flex items-center"
};
const _hoisted_23 = {
  key: 6,
  class: "py-2"
};
const _hoisted_24 = {
  class: "py-2"
};
const _hoisted_25 = {
  class: "w-full"
};
import { Player } from "@/modules/team/entity";
import { onBeforeRouteLeave } from "vue-router";
import NegotiationFields from "@/modules/diplomacy/components/NegotiationFields.vue";
import { app } from "@/di";
import MarketValueCalculator from "@/modules/team/services/MarketValueCalculator";
import Flag from "@/modules/vue/components/Flag.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import Card from "@/modules/match/components/Card.vue";
import Talent from "@/modules/youth/components/Talent.vue";
import AttributeGroup from "@/modules/vue/components/AttributeGroup.vue";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
import PlayerLayout from "@/modules/team/pages/players/PlayerLayout.vue";
import Gate from "@/modules/action-points/components/Gate.vue";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import PlayerInfo from "@/modules/team/components/PlayerInfo.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Data',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const player = ref();
    const marketValue = ref();
    const scoutingCost = ref(app.get(ConfigRepository).get('scouting.actionPointsCosts.talent'));
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      const playerId = route.params.id;
      player.value = await Player.createQueryBuilder('player').leftJoinAndSelect('player.team', 'team').innerJoinAndSelect('player.country', 'country').leftJoinAndSelect('team.country', 'teamCountry').leftJoinAndSelect('player.suspensions', 'suspension').leftJoinAndSelect('suspension.competition', 'competition').leftJoinAndSelect('competition.country', 'competitionCountry').where('player.id = :playerId', {
        playerId
      }).getOneOrFail();
      marketValue.value = await app.get(MarketValueCalculator).calculate(player.value);
    })), __temp = await __temp, __restore(), __temp);
    const onScoutingTalent = async commit => {
      player.value.revelation = 100;
      await player.value.save();
      await commit();
      refresh();
    };
    onBeforeRouteLeave(watch(() => route.params, refresh));
    return (_ctx, _cache) => {
      const _component_NAlert = _resolveComponent("NAlert");
      return _openBlock(), _createBlock(PlayerLayout, {
        onUpdated: _unref(refresh)
      }, {
        default: _withCtx(() => [player.value.team ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Flag, {
          country: player.value.team.country,
          class: "mr-2"
        }, null, 8, ["country"]), _createVNode(EntityLink, {
          entity: player.value.team
        }, null, 8, ["entity"])])) : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('without_club')), 1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
          src: player.value.image,
          alt: player.value.name,
          class: "w-24 h-24 -mb-6"
        }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createVNode(PlayerInfo, {
          class: "mr-4 uppercase"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(player.value.position), 1)]),
          _: 1
        }), _createVNode(PlayerInfo, {
          unknown: player.value.revealedTalent === null,
          class: "mr-4"
        }, {
          default: _withCtx(() => [_createVNode(Talent, {
            talent: player.value.revealedTalent,
            size: "3rem"
          }, null, 8, ["talent"])]),
          _: 1
        }, 8, ["unknown"]), _createVNode(PlayerInfo, {
          unknown: player.value.revealedSkill === null
        }, {
          default: _withCtx(() => [player.value.revealedSkill === null ? (_openBlock(), _createElementBlock("div", _hoisted_7, "00")) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(Math.floor(player.value.revealedSkill)), 1)], 64))]),
          _: 1
        }, 8, ["unknown"])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('nationality')), 1), _createElementVNode("div", _hoisted_11, [_createVNode(Flag, {
          country: player.value.country
        }, null, 8, ["country"])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('age')), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(player.value.age), 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('value')), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$money(marketValue.value)), 1)]), player.value.revealedTalent === null ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createVNode(Gate, {
          type: _ctx.GateTypeEnum.SCOUTING,
          value: scoutingCost.value,
          "no-confirm": "",
          onAction: onScoutingTalent
        }, null, 8, ["type", "value"])])], 64)) : _createCommentVNode("", true)]), player.value.transferred ? (_openBlock(), _createBlock(_component_NAlert, {
          key: 2,
          type: "success",
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('player_has_been_transferred_this_season')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), player.value.endsCareer ? (_openBlock(), _createBlock(_component_NAlert, {
          key: 3,
          type: "warning",
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('the_player_will_end_career_at_the_end_of_his_contract')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), player.value.careerEndedAt ? (_openBlock(), _createBlock(_component_NAlert, {
          key: 4,
          type: "warning",
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('player_has_ended_his_career_at', {
            date: _ctx.$date(player.value.careerEndedAt)
          })), 1)]),
          _: 1
        })) : _createCommentVNode("", true), player.value.suspensions.length > 0 ? (_openBlock(), _createBlock(_component_NAlert, {
          key: 5,
          type: "error",
          "show-icon": false,
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('player_is_suspended')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(player.value.suspensions, suspension => {
            return _openBlock(), _createElementBlock("div", {
              key: suspension.id,
              class: "flex flex-col border-b last:border-b-0"
            }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(Card, {
              card: suspension.card,
              class: "mr-2"
            }, null, 8, ["card"]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('x_matches_remaining_suspension', {
              x: suspension.remainingMatches
            })), 1)]), suspension.competition.country ? (_openBlock(), _createBlock(Flag, {
              key: 0,
              country: suspension.competition.country,
              class: "mr-1"
            }, null, 8, ["country"])) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString(suspension.competition.name), 1)])]);
          }), 128))]),
          _: 1
        })) : _createCommentVNode("", true), player.value.contractYears ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(AttributeGroup, {
          color: _ctx.ColorEnum.Rose,
          title: _ctx.$t('contract_details')
        }, {
          default: _withCtx(() => [_createVNode(FormGroup, {
            label: _ctx.$t('duration')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$duration(player.value.contractYears, 'years').humanize()), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(FormGroup, {
            label: _ctx.$t('wage')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$money(player.value.wage)), 1)]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["color", "title"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_24, [_createVNode(NegotiationFields, {
          entity: player.value,
          class: "mb-4"
        }, null, 8, ["entity"]), _ctx.$debug ? (_openBlock(), _createBlock(AttributeGroup, {
          key: 0,
          class: "mb-4",
          color: _ctx.ColorEnum.Red,
          title: _ctx.$t('debug'),
          attributes: [{
            label: _ctx.$t('energy'),
            percentage: player.value.energy
          }, {
            label: _ctx.$t('base_form'),
            percentage: player.value.baseForm
          }, {
            label: _ctx.$t('form'),
            percentage: player.value.form
          }]
        }, {
          after: _withCtx(() => [_createVNode(FormGroup, {
            label: _ctx.$t('next_form_change_at')
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$date(player.value.nextFormChangeAt)), 1)]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["color", "title", "attributes"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["onUpdated"]);
    };
  }
});